import http from '../../../api/axios';
import { apiUrl } from '../../../api/apiUrl';
import { Values } from '../../../forms/CurrencyRates/CurrencyRatesForm.types';
import { handleApiErrors } from '../../../api/apiErrorHandler';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { CurrencyRatesForm } from '../../../forms/CurrencyRates/CurrencyRatesForm';
import { Loader } from '../../../components/loader/Loader';
import { CurrencyRate } from '../../../types/Currency';
import { useTranslation } from '../../../context/translationContext';
import { paths } from '../../RouterContainer';
import { COMPANY_TABS } from '../Company/UserCompaniesUpdatePage';
import { useBreadcrumbs } from '../../../hooks/useBreadcrumbs';
import { useLoading } from '../../../context/loadingContext';

/**
 * Component for editing existing currency rate of company
 */
export const CurrencyRatesUpdatePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id, companyId } = useParams();
  const [data, setData] = useState<CurrencyRate | null>(null);
  const { startLoading, stopLoading } = useLoading();
  const { setBreadcrumbs } = useBreadcrumbs();
  const isCurrent = window.location.pathname.includes(`current`);
  useEffect(() => {
    setBreadcrumbs([
      {
        path: `${paths.MY_COMPANIES}`,
        name: 'navigation.my-companies',
      },
      {
        path: `${paths.MY_COMPANIES}/edit/${isCurrent ? `current` : companyId}`,
        name: 'navigation.company-setting',
      },
      {
        path: `${paths.MY_COMPANIES}/${isCurrent ? `current` : companyId}/${paths.COMPANY_CURRENCY_RATES}/edit/${id}`,
        name: 'navigation.currency-rate-edit',
      },
    ]);
  }, []);

  /**
   * Back button action
   */
  const handleOnBack = () =>
    navigate(`/${paths.MY_COMPANIES}/edit/${isCurrent ? `current` : companyId}`, {
      state: { tab: COMPANY_TABS.CURRENCY_RATES },
    });

  /**
   * Loads currency rates
   */
  const fetchData = async () => {
    const response = await http.apiGet({
      url: `${apiUrl.COMPANY_CURRENCY_RATES_ITEM}?id=${id}`,
    });
  setData(response?.data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  /**
   * Handles edit action for new currency rate.
   * @param values form data
   */
  const handleSubmit = async (values: Values) => {
    try {
      startLoading();
      const response = await http.apiPut({
        url: apiUrl.COMPANY_CURRENCY_RATES_UPDATE,
        data: values,
      });
      if (response?.status === 200) {
        stopLoading();
        toast.success('Success!');
      }
    } catch (err) {
      stopLoading();
      handleApiErrors(err);
    }
  };

  if (!data) return <Loader />;
  return (
    <>
      <div className="flex flex-row">
        <div className="w-1/4	space-y-8">
          <h1 className="text-3xl font-bold">{t('page.currency-rates.headline-edit')}</h1>
          <CurrencyRatesForm
            onSubmit={handleSubmit}
            initialValues={data as Values}
            onBack={handleOnBack}
          />
        </div>
      </div>
    </>
  );
};
